import { render } from "./summary-section.vue?vue&type=template&id=33e2d36c&ts=true"
import script from "./summary-section.vue?vue&type=script&lang=ts"
export * from "./summary-section.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__